<section class="not-found is-flex has-flex-align-center has-flex-content-space-around">
  <img src="{{'/assets/BalloonLarge.svg' | staticp}}" class="hide-on-mobile" alt="REMAX Logo" height="400"/>
  <div class="is-flex-column has-flex-align-start has-flex-content-space-around full-height">
    <h1 translate="meta-tags.page-not-found.h1"></h1>
    <h4 translate="page-not-found.looking-for"></h4>
    <a [routerLink]="['/home']" class="btn btn-primary btn-back" translate="page-not-found.search-listings"></a>
  </div>
</section>
